import { Button, Centered } from '@cof/omni-react';
import { LowerHalf } from '@components/global';

interface CTAProps {
  primaryText: string;
  primaryCallback: () => void;
  secondaryText?: string;
  secondaryCallback?: () => void;
}

export const CTA = ({
  primaryText,
  secondaryText,
  primaryCallback,
  secondaryCallback,
}: CTAProps) => {
  return (
    <LowerHalf data-testid="CTA">
      <Centered style={{ padding: '20px' }}>
        <Button
          data-testid="CTA--primaryButton"
          width="100%"
          style={{ marginBottom: '20px' }}
          rank="primary"
          onClick={primaryCallback}
        >
          {primaryText}
        </Button>
        {secondaryText && secondaryCallback ? (
          <Button
            data-testid="CTA--secondaryButton"
            rank="tertiary"
            style={{ marginBottom: '20px' }}
            onClick={secondaryCallback}
          >
            {secondaryText}
          </Button>
        ) : null}
      </Centered>
    </LowerHalf>
  );
};
